<ion-card
  class="border-r10 grey-border no-shadow bg-white ion-no-margin ion-padding marb10"
  (click)="viewOfferProducts()"
>
  <div class="d-flex ion-justify-content-between ion-align-items-center">
    <ion-card-title class="fs-4 font600 card-primary-text-color title">{{
      offerItem?.offer
    }}</ion-card-title>
    <ion-icon name="chevron-forward-outline" class="marl10 primary-icon-color arrow-icon"></ion-icon>
  </div>
</ion-card>
